<template>
  <div :class="['splash-lottie', {'lottie-blur': !isShowLottieStatic && isShowScreenAni}]">
    <div class="ani-bg" v-if="isShowLottieStatic"></div>
    <van-popup v-model="isShowScreenAni" :style="{ width: '100%' }">
      <div class="ani" ref="screenAni1" v-show="isShowScreenAni1"></div>
      <div class="ani" ref="screenAni2" v-show="isShowScreenAni2"></div>
      <div class="ani" ref="screenAni3" v-show="isShowScreenAni3"></div>
      <div class="ani" ref="screenAni4" v-show="isShowScreenAni4"></div>
    </van-popup>
    <div class="lottie-colse" v-if="isShowLottieStatic || isShowScreenAni" @click.once="closeLottie">进入活动</div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import lottie from 'lottie-web';
import { monitor } from '@/common/monitor';
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import { lxConfig } from '@/analytic/profilePhoto';
import { lotteryActivityId } from '@/common/config';

Vue.use(Popup);

export default {
  props: {
    cityCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      screenAni1: {},
      screenAni2: {},
      screenAni3: {},
      screenAni4: {},
      isShowScreenAni: true,
      isShowLottieStatic: true,
      isShowScreenAni1: false,
      isShowScreenAni2: false,
      isShowScreenAni3: false,
      isShowScreenAni4: false
    };
  },
  mounted() {
    this.screenAni1 = lottie.loadAnimation({
      container: this.$refs.screenAni1,
      renderer: 'svg',
      name: 'name',
      loop: false,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/firstAni-20221209.json'
    });
    this.screenAni2 = lottie.loadAnimation({
      container: this.$refs.screenAni2,
      renderer: 'svg',
      name: 'name',
      loop: false,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/second-20221209.json'
    });
    this.screenAni3 = lottie.loadAnimation({
      container: this.$refs.screenAni3,
      renderer: 'svg',
      name: 'name',
      loop: false,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/thirdAni-20221209.json'
    });
    this.screenAni4 = lottie.loadAnimation({
      container: this.$refs.screenAni4,
      renderer: 'svg',
      name: 'name',
      loop: false,
      autoplay: false,
      path: 'https://s3plus.meituan.net/v1/mss_8d74a500df2d46269414be356ca2e522/ecny-package/forthAni-20221209.json'
    });
    const p1 = this.loadScreenAni('screenAni1');
    const p2 = this.loadScreenAni('screenAni2');
    const p3 = this.loadScreenAni('screenAni3');
    const p4 = this.loadScreenAni('screenAni4');
    this.loadComplete([p1, p2, p3, p4]);
    this.screenAni1.addEventListener('complete', () => {
      this.isShowScreenAni1 = false;
      this.screenAni1.destroy();
      this.screenAni2.play();
      this.isShowScreenAni2 = true;
    });
    this.screenAni2.addEventListener('complete', () => {
      this.isShowScreenAni2 = false;
      this.screenAni2.destroy();
      this.screenAni3.play();
      this.isShowScreenAni3 = true;
    });
    this.screenAni3.addEventListener('complete', () => {
      this.isShowScreenAni3 = false;
      this.screenAni3.destroy();
      this.screenAni4.play();
      this.isShowScreenAni4 = true;
    });
    this.screenAni4.addEventListener('complete', () => {
      this.isShowScreenAni4 = false;
      this.screenAni4.destroy();
      this.isShowScreenAni = false;
    });
    this.screenAni1.setSubframe(false);
    this.screenAni2.setSubframe(false);
    this.screenAni3.setSubframe(false);
    this.screenAni4.setSubframe(false);
  },
  watch: {
    isShowScreenAni: {
      handler() {
        if (!this.isShowScreenAni) {
          // 露出主页内容
          this.$emit('aniComplete');
        }
      },
      immediate: true
    }
  },
  methods: {
    loadScreenAni(ani) {
      return new Promise((resolve) => {
        this[ani].addEventListener('data_ready', () => {
          resolve();
        });
      });
    },
    loadComplete(paramsList) {
      Promise.all(paramsList).then(() => {
        this.isShowLottieStatic = false;
        this.isShowScreenAni1 = true;
        this.screenAni1.play();
        lx.pv(lxConfig.animation_pv, {
          from: env.from || -999,
          activity_id: env.actGroupName || lotteryActivityId,
          city_id: (this.divisionInfo && this.divisionInfo.cityCode) || -999
        });
      }).catch((err) => {
        monitor.captureMessage(
          {
            name: '【好彩头】加载lottie失败',
            msg: JSON.stringify(err)
          },
          {
            level: 'error'
          }
        );
      });
    },
    closeLottie() {
      this.isShowLottieStatic = false;
      this.isShowScreenAni = false;
      lx.addTag({
        c_fsp_dcep_q0ecxbr1: {
          bid: lxConfig.jump_animation_mc
        }
      });
      lx.mc(lxConfig.jump_animation_mc, {
        from: env.from || -999,
        activity_id: env.actGroupName || lotteryActivityId,
        city_id: this.cityCode || -999
      }, {
        cid: lxConfig.animation_pv
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../styles/fn.less";
.lottie-blur {
  /deep/.van-overlay {
    background: transparent;
    opacity: 0.9;
    backdrop-filter: blur(0.2rem);
  }
}
.splash-lottie {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100000;
  /deep/.van-overlay {
    background: transparent;
  }
  .van-popup {
    background: transparent;
    overflow: hidden;
  }
  .ani-bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 9999;
    min-height: 100vh;
    background-position: center;
    .bg-image-auto('https://p0.meituan.net/wxapp/fbe769e234a09fe17a25015b2f11d367166435.png');
    background-color: #ED3850;
  }
  .ani {
    z-index: 2;
    position: relative;
  }
  .lottie-colse {
    z-index: 10000;
    position: absolute;
    top: 1.06rem;
    right: 0.34rem;
    width: 1.83rem;
    height: 0.59rem;
    line-height: 0.59rem;
    background: rgba(0,0,0,0.4);
    border: 1px solid #FFFFFF;
    border-radius: 0.3rem;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    color: #FFFFFF;
    font-weight: 400;
  }
}
</style>
